var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.143,
    height: 8.5,
    viewBox: "0 0 5.143 8.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M4.25,5.143H4.241a.88.88,0,0,1-.183-.021l-.026-.007-.024-.007a.71.71,0,0,1-.088-.03L3.9,5.069a.708.708,0,0,1-.082-.04l-.034-.021a.66.66,0,0,1-.067-.046,1.01,1.01,0,0,1-.1-.087L.256,1.5A.878.878,0,0,1,.879,0,.866.866,0,0,1,1.5.259L3.722,2.491l.528.56.532-.564L7,.258A.877.877,0,0,1,8.5.875a.871.871,0,0,1-.256.621L4.872,4.883h0l-.005.005h0a.867.867,0,0,1-.146.117l-.036.021a.7.7,0,0,1-.083.042l-.019.007a.709.709,0,0,1-.087.031l-.026.006-.024.006a.634.634,0,0,1-.07.014l-.049,0A.621.621,0,0,1,4.25,5.143Z",
    transform: "translate(0 8.5) rotate(-90)",
    fill: "#1b2737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionToggle);
export default __webpack_public_path__ + "static/media/SectionToggle.e615403c0536eb5bd93caf6d43bc5a29.svg";
export { ForwardRef as ReactComponent };